const state = {
    termsOfUseUrl: 'https://pappyon.com/terms-of-use/',
    privacyPolicyUrl: 'https://pappyon.com/privacy-policy/',
    supportUrl: 'https://pappyon.com/help',
    pricingUrl: 'https://pappyon.com/pricing/',   
    contactUrl: 'https://pappyon.com/contact/',
};

const getters = {
    termsOfUseUrl: (state) => state.termsOfUseUrl,
    privacyPolicyUrl: (state) => state.privacyPolicyUrl,
    supportUrl: (state) => state.supportUrl,
    pricingUrl: (state) => state.pricingUrl,
    contactUrl: (state) => state.contactUrl,
};

const actions = {};

const mutations = {};

export default {
    state,
    getters,
    actions,
    mutations
}
